import React, { useState, useContext, useEffect, useRef } from "react";
import { Link, useLocation, Navigate } from "react-router-dom";
import "./login.css";
import "./log.css";
import { LoginStatusContext } from "../contexts/LoginStatusContext";
import { LoginContext } from "../contexts/LoginContext";
import { APIURL,TZ } from "../../Global";
import axios from "axios";
import background from "../../assets/images/bg.jpg";
import { HospLoginContext } from "../contexts/HospitalLoginContext";
import AuthUtil from "./AuthUtil";
import home from "../../assets/images/newww.png";
import LoadingOverlay from "react-loading-overlay";
// import orgData from "../../felixaconfig.json"
function LoginPage() {
  const [loginUsername, setLoginUsername] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [passwordType, setPasswordType] = useState("password");
  const [, setHospData] = useContext(HospLoginContext);
  //const [, setHospDocData] = useContext(HospDrLoginContext);
  const location = useLocation();
  const [, setLoginDatas] = useContext(LoginContext);
  const [, setIsLoggedIn] = useContext(LoginStatusContext);
  const [error, setError] = useState(false);
  const [serveCount, setServeCount] = useState("");
  const [aggregator, setAggregator] = useState('');
  const [orgImg, setOrgImg] = useState("")
  const [orgFlag, setOrgFlag] = useState(false)
const [loading,setLoading]=useState(false)
  const [regcount, setRegCount] = useState('');
 
  const [isUser,setIsUser]=useState(false)
  const inputRefs = useRef([])
  const loginButtonRef = useRef (null)
  
  const handleKeyDown = (e, index) => {
    if (e.key === "Enter") {  
      e.preventDefault()
      if(index === 1 ) {
        loginButtonRef.current.click();
      }else{
      e.preventDefault();
      const nextIndex = index + 1;
      if (nextIndex < inputRefs.current.length && inputRefs.current[nextIndex]) {
        inputRefs.current[nextIndex].focus();
      }
    }
    }
  };
  const handleKey = (e) => {
    if (e.key === "Enter") {
      e.preventDefault()
      const activeElement = document.activeElement;
      if (
        !inputRefs.current.includes(activeElement) &&
        activeElement !== loginButtonRef.current
      ) {
        loginButtonRef.current.click();
      }
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKey);  
    return () => {
      document.removeEventListener("keydown", handleKey);
    };
  }, []);

  useEffect(() => {
    setLoginDatas(null);
    setIsLoggedIn(false);
  }, []);


 

  const handleLogin = async (e) => {
    sessionStorage.removeItem("status");
    e.preventDefault();
    await apiCall();
  };

  const handleChange = (e) => {
    e.preventDefault();
    const val = e.target.value;
    const key = e.target.name;
    if (key === "loginUsername") {
      setLoginUsername(val);
    }
    if (key === "loginPassword") {
      setLoginPassword(val);
    }
  };
  const togglePasswordVisiblity = (e) => {
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };

  const apiCall = () => {
    let user=""
    axios
      .post(
        `${APIURL}/api/v1/account/login/`,
        {
          username: loginUsername,
          password: loginPassword,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
  
      .then((res) => {
        if (res.data.status === "success") {
        
          user=res.data.user_type
         
          if (res.data.verification_status === "pending") {
            sessionStorage.setItem("hosp_data", JSON.stringify(res.data));
            sessionStorage.setItem("hospital_pending", "true");
            setHospData(res.data);
          }
          if(user==="config_admin"||user==="sales_admin"|user==="staff" ){
            setIsUser(true)
            console.log("user is true")
            
            sessionStorage.setItem("logindatas", JSON.stringify(res.data));
            sessionStorage.setItem("userid", res.data.user_id);
            sessionStorage.setItem("hospId", res.data.hospital_id);
            sessionStorage.setItem("role", res.data.role);
            sessionStorage.setItem("aggr_type", aggregator);
            setLoginDatas(res.data);
            /* Store Token */
            sessionStorage.setItem("usertoken", JSON.stringify(res.data.token));
    
            sessionStorage.setItem("usertype", res.data.user_type);
            sessionStorage.setItem("verified_login", false);
           
        }
        
         
        } else {
          setLoginUsername("");
          setLoginPassword("");
          setError(res.data.message);
        }
      })
      .catch(() => {
        setLoginUsername("");
        setLoginPassword("");
        setError("There was some error in login");
      });
  };

  const authUrl = sessionStorage.getItem("usertoken")&&AuthUtil.validateAuth();
  if (authUrl&&isUser) {
    return <Navigate to={authUrl} state={{ from: location }} />;
  }

  return (
    <>
     <LoadingOverlay
            active={loading}
            
        >
      <div className="App">
        <div className="appAside">
          <article class="card1">
            <img src={orgFlag ? orgImg : home} class="card__img" />
            <div class="card__data">
              <h6 class="card__title"><b>Stay healthy, stay informed, and let Felixa Touch take care of you</b></h6>
              <p class="card__description">Get healthcare at your fingertips with the Felixa Touch. Book appointments hassle-free and skip long waiting lines. Access trusted reviews, check fees, and make informed choices—all in one place. Felixa Touch connects you to a network of experienced healthcare providers and offers comprehensive resources for all your wellness needs.</p>
              <a href="https://aacc.gov.mt/st-vincent-de-paul-long-term-care-facility" class="card__btn">Learn more</a>
            </div>
          </article>

        </div>
        <div className="appForm">
          <div className="formData">
            <div className="formdata1">
              <h2 className="name" style={{color:"white"}}>Login</h2>
            </div>
            <div className="formFields">
              <div className="formField">
                <input
                  ref={el => inputRefs.current[0] = el} 
                  onKeyDown={(e) => handleKeyDown(e,0)}
                  type="text"
                  className="formFieldInput"
                  name="loginUsername"
                  placeholder={"Username"}
                  value={loginUsername}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="formField">
                <div
                  className=""
                  style={{ backgroundColor: "#e8f0fe", position: 'relative', borderRadius: 20 }}
                >
                  <input
                    ref={el => inputRefs.current[1] = el} 
                    onKeyDown={(e) => handleKeyDown(e,1)}
                    style={{ backgroundColor: "#e8f0fe" }}
                    type={passwordType}
                    className="formFieldInput"
                    value={loginPassword}
                    name="loginPassword"
                    placeholder={"Password"}
                    onChange={handleChange}
                    required
                  />
<span style={{ float: "right", top: 10, right: 10, position: 'absolute', color: 'black' }}>
                    {/* <button className="btn btn-outline-primary1" onClick={togglePasswordVisiblity}> */}
                    {passwordType === "password" ? (
                      <i
                        className="fa fa-eye-slash"
                        onClick={togglePasswordVisiblity}
                      ></i>
                    ) : (
                      <i
                        className="fa fa-eye"
                        onClick={togglePasswordVisiblity}
                      ></i>
                    )}
                    {/* </button> */}
</span>
                </div>
              </div>

              <div className="forgot-password" >
                <Link style={{color:"white"}} to="/forgot-password">Forgot password?</Link>
              </div>

              <div className="formField formButtonLayout">
                <button ref={loginButtonRef} className="formFieldButton" onClick={handleLogin} style={{ cursor: "pointer !important" }}>
                  Sign In
                </button>


                {/* {regcount < serveCount ?
                  <Link
                    to="/signup"
                    className="formFieldButton"
                    style={{ textDecoration: "none" }}
                  >
                    {" "}
                    Create an account{" "}
                  </Link> :
                  <Link
                    to="/ErrorNotification"
                    className="formFieldButton"
                    style={{ textDecoration: "none" }}
                  >
                    {" "}
                    Create an account{" "}
                  </Link>} */}
              </div>
              <div className="formField">
                {error ? (
                  <div>
                    <p className="login-error" style={{ color: "red" }}>
                      {"Error"}:{" "}
                      {error === "Invalid credentials"
                        ? "Invalid credentials"
                        : error === "There was some error in login"
                          ? "There was some error in login"
                          : error}{" "}
                      <br />
                      {"Please try again!"}
                    </p>{" "}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="headerdata1" />
      </LoadingOverlay>
    </>
  );
}

export default LoginPage;
